import { __assign, __rest } from "tslib";
/**
 * Inserts JS into a <script> tag on the DOM.
 */
export var insertScriptIntoDom = function (script, id, doc) {
    if (doc === void 0) { doc = document; }
    if (!script) {
        return;
    }
    var scriptElement = doc.createElement('script');
    scriptElement.type = 'text/javascript';
    scriptElement.textContent = script;
    if (id) {
        removeElementById(id);
        scriptElement.id = id;
    }
    doc.body.appendChild(scriptElement);
};
/**
 * Insert CSS into a <style> tag on the DOM.
 * Provide `id` to ensure it only insert once
 */
export var insertCSSIntoDom = function (cssStr, id, doc) {
    if (doc === void 0) { doc = document; }
    var styleElement = doc.createElement('style');
    styleElement.type = 'text/css';
    styleElement.innerHTML = cssStr;
    if (id) {
        removeElementById(id);
        styleElement.id = id;
    }
    doc.head.appendChild(styleElement);
};
/**
 * Apply an object of CSS properties to a HTML Element.
 */
export var css = function (el, styles) {
    for (var property in styles) {
        if (Object.prototype.hasOwnProperty.call(styles, property)) {
            el.style[property] = styles[property];
        }
    }
};
/**
 * Remove an HTML element from the DOM.
 */
export var removeElementById = function (id) {
    var element = document.getElementById(id);
    if (!element || !element.parentNode) {
        return;
    }
    element.parentNode.removeChild(element);
};
/**
 * Set CSS styles on an HTML element.
 */
export var setStyles = function (element, newStyles) {
    return Object.keys(newStyles).forEach(function (style) {
        element.style[style] = newStyles[style];
    });
};
/**
 * Combine transform-related CSS pseudo-properties (scaleX, translateX, etc.)
 * into one `transform` property. Returns unrelated CSS properties as is.
 *
 * `{ scaleX: 2, scaleY: 3 }` -> `{ transform: 'scaleX(2) scaleY(3)' }`
 */
export var translateTransformStyles = function (styles, rotate) {
    if (rotate === void 0) { rotate = '0deg'; }
    var _a = styles.translateX, translateX = _a === void 0 ? '0%' : _a, _b = styles.translateY, translateY = _b === void 0 ? '0%' : _b, _c = styles.scaleX, scaleX = _c === void 0 ? 1 : _c, _d = styles.scaleY, scaleY = _d === void 0 ? 1 : _d, _e = styles.skewX, skewX = _e === void 0 ? '0deg' : _e, _f = styles.skewY, skewY = _f === void 0 ? '0deg' : _f, nonTransformProps = __rest(styles, ["translateX", "translateY", "scaleX", "scaleY", "skewX", "skewY"]);
    var translateXNumber = parseFloat("" + translateX);
    var translateYNumber = parseFloat("" + translateY);
    var scaleXNumber = parseFloat("" + scaleX);
    var scaleYNumber = parseFloat("" + scaleY);
    var scaleXOffset = ((1 - scaleXNumber) / 2) * 100;
    var scaleYOffset = ((1 - scaleYNumber) / 2) * 100;
    var translateXOffset = translateXNumber - scaleXOffset + "%";
    var translateYOffset = translateYNumber - scaleYOffset + "%";
    var transforms = {
        translate: translateXOffset + ", " + translateYOffset,
        rotate: rotate,
        scale: scaleX + ", " + scaleY,
        skew: skewX + ", " + skewY,
    };
    var transform = Object.keys(transforms)
        // @ts-ignore
        .map(function (key) { return key + "(" + transforms[key] + ")"; })
        .join(' ');
    return __assign(__assign({}, nonTransformProps), { transform: transform });
};
export var dispatchGlobalEvent = function (eventName, eventData) {
    if (eventData === void 0) { eventData = {}; }
    var event = new CustomEvent(eventName, {
        detail: eventData,
    });
    document.dispatchEvent(event);
};
/**
 * Converts a string of HTML into a node
 */
export var htmlStringToNode = function (htmlString) {
    var node = document.createElement('span');
    node.innerHTML = htmlString;
    return node;
};
/**
 * Converts a string of HTML to plain text.
 */
export var textFromHtmlString = function (htmlString) {
    return htmlStringToNode(htmlString).textContent || '';
};
/**
 * Convert a NodeList to an array, allowing
 * the use of `map()`, `filter()`, etc.
 */
export var nodeListToArray = function (input) {
    return Array.prototype.slice.apply(input);
};
/**
 * Get window size: width and height
 */
export var getWindowSize = function () {
    var width = window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
    var height = window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight;
    return {
        width: width,
        height: height,
        isOnMobileDevice: width < 750,
    };
};
/**
 * Detect if an HTML Element has overflow.
 *
 * I HATE INTERNET EXPLORER.
 *
 * Because our measurements are based on percentages, they may be fractions
 * of a pixel and get rounded. IE may round scrollWidth & scrollHeight *up*,
 * while rounding clientWidth and clientHeight *down*, meaning the scroll
 * measurements will always be larger than the client measurements. So we
 * subtract a pixel from the scroll measurements to avoid this.
 */
export var hasOverflow = function (element) {
    return element.scrollWidth - 1 > element.clientWidth ||
        element.scrollHeight - 1 > element.clientHeight;
};
